var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(["\n    width: 100px;\n  "], ["\n    width: 100px;\n  "]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n    ", "\n  "], ["\n    ", "\n  "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled, { ThemeContext } from "styled-components";
import { media } from "../../index";
import { breakPointArrayCleaner } from "../../utils";

var Horizon = function Horizon(props) {
  var theme = useContext(ThemeContext);

  var color = props.color,
      align = props.align,
      restProps = _objectWithoutProperties(props, ["color", "align"]);

  if (theme.colors[color]) {
    color = theme.colors[color];
  } else if (theme[color]) {
    color = theme[color];
  }

  if (align === null) {
    if (theme.typoTextAlign === "center") {
      align = "center";
    } else {
      align = "left"; // default
    }
  }

  return React.createElement(HorizonStyled, _extends({
    align: breakPointArrayCleaner(align),
    color: color
  }, restProps));
};

export { Horizon };
Horizon.propTypes = process.env.NODE_ENV !== "production" ? {
  align: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  color: PropTypes.string,
  gutterBottom: PropTypes.bool
} : {};

Horizon.defaultProps = {
  align: null,
  color: "primaryLight",
  gutterBottom: false
};

var HorizonStyled = styled.div.withConfig({
  displayName: "Horizon__HorizonStyled",
  componentId: "sc-1hkf3k3-0"
})(["height:4px;border-radius:100px;width:56px;background-color:", ";", " ", ";", ";", ";", ";margin-bottom:", ";"], function (props) {
  return props.color;
}, media.desktop(_templateObject), media.phone(_templateObject2, function (props) {
  if (props.align[0] === "left") return "margin-left: 0; margin-right: 0;";
  if (props.align[0] === "center") return "margin-left: auto; margin-right: auto;";
}), media.tablet(_templateObject2, function (props) {
  if (props.align[1] === "left") return "margin-left: 0; margin-right: 0;";
  if (props.align[1] === "center") return "margin-left: auto; margin-right: auto;";
}), media.desktop(_templateObject2, function (props) {
  if (props.align[2] === "left") return "margin-left: 0; margin-right: 0;";
  if (props.align[2] === "center") return "margin-left: auto; margin-right: auto;";
}), media.wide(_templateObject2, function (props) {
  if (props.align[3] === "left") return "margin-left: 0; margin-right: 0;";
  if (props.align[3] === "center") return "margin-left: auto; margin-right: auto;";
}), function (props) {
  return props.gutterBottom ? "1.5rem" : "none";
});